export default "__VITE_ASSET__YlP4W5Bo__"